<template>
  <div class="survey__form">
    <h2 class="text-center mt-3 mb-0">
      Ontvang gratis advies én maak kans op een Rituals pakket t.w.v. € 90,-!
    </h2>

    <form @submit.prevent="() => submitForm(fields)" class="mt-4 mx-auto">
      <div class="form-group">
        <label for="email" class="sr-only">
          E-mailadres
        </label>

        <div class="d-flex">
          <input
            id="email"
            type="email"
            class="form-control"
            v-model="fields.email"
            placeholder="Jouw e-mailadres..."
            autocomplete="off"
            required
          >

          <button
            class="btn btn--secondary ml-2"
            type="submit"
            :disabled="processing"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="26.27" height="26.28">
              <path d="M24.43.17.64 13.89a1.23 1.23 0 0 0 .11 2.22l5.46 2.29 14.74-13a.3.3 0 0 1 .44.43L9.03 20.89v4.13a1.23 1.23 0 0 0 2.18.81l3.26-3.97 6.4 2.68a1.24 1.24 0 0 0 1.7-.93l3.7-22.17A1.23 1.23 0 0 0 24.42.17Z" fill="#fff"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="d-flex flex-column align-items-center form-group">
        <input
          id="agreement"
          type="checkbox"
          v-model="fields.agreement"
          required
        >

        <label for="agreement" class="font-size-sm lheight-none">
          Ik ga akkoord met de <a href="https://www.silvana.nl/disclaimer-slaapwijzer" target="_blank">Silvana Slaapwijzer voorwaarden</a> *
        </label>

        <div class="font-size-sm lheight-none text-center color-mute mt-3">
          Je e-mailadres wordt enkel gebruikt voor onze actie rondom de slaapwijzer.
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      fields: {
        email: '',
        agreement: false,
      },
    };
  },

  computed: {
    ...mapGetters([
      'processing',
    ]),
  },

  methods: {
    ...mapActions([
      'submitForm',
    ]),
  },
};
</script>
